/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";

import { Utils } from "arv-reactcomponents";
import { isDesktop } from "../../../utils";
import { pageType } from "../../../constants";
import Anchor from "../../Anchor";
import { filterApiResponceWithoutBrand } from "../../../stores/SearchBarStore/__test__/mocks";

const ColorChip = props => {
  const historyState = link => {
    return {
      pathname: link,
      state: {
        currentPage: pageType.pdp,
      },
    };
  };
  const { color, onHover, setStyle, isSelected, className } = props;
  const { swatchImage, hexCode } = color;
  let style = {
    backgroundColor: hexCode,
    backgroundImage: `url( ${swatchImage} )`,
    cursor: "pointer",
  };
  if (isSelected) {
    style.cursor = "default";
    const selected = "selected";
    if (isDesktop) {
      return (
        <Anchor
          role="button"
          className={`nw-color-item ${className} ${selected}`}
          style={style}
          key={color.styleId}
          href={color.url}
          to={color.url}
          onMouseOver={() => onHover(color)}
          onClick={e => e.preventDefault()}
        />
      );
    }
    return (
      <div
        role="button"
        className={`nw-color-item ${className} ${selected}`}
        style={style}
        key={color.styleId}
        href={color.url}
        to={historyState(color.url)}
      />
    );
  }
  if (isDesktop) {
    return (
      <Anchor
        role="button"
        className={`nw-color-item ${className}`}
        style={style}
        key={color.styleId}
        href={color.url}
        to={color.url}
        onClick={e => setStyle(e, color.styleId, color.mainImage, color)}
        onKeyPress={e => setStyle(e, color.styleId, color.mainImage)}
        onMouseOver={() => onHover(color)}
        tabIndex="0"
      />
    );
  }
  return (
    <Anchor
      role="button"
      className={`nw-color-item ${className}`}
      style={style}
      key={color.styleId}
      href={color.url}
      to={historyState(color.url)}
      onClick={e => setStyle(e, color.styleId, color.mainImage, color)}
      onKeyPress={e => setStyle(e, color.styleId, color.mainImage)}
      tabIndex="0"
    />
  );
};

ColorChip.defaultProps = {
  onHover: Utils.noop,
  setStyle: Utils.noop,
  isSelected: false,
  className: "",
};

ColorChip.propTypes = {
  className: PropTypes.string,
  color: PropTypes.object.isRequired, // eslint-disable-line
  onHover: PropTypes.func,
  setStyle: PropTypes.func,
  isSelected: PropTypes.bool,
};
export default ColorChip;



// WEBPACK FOOTER //
// ./src/component/ProductList/ColorChip/index.js